"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = (0, _styles.makeStyles)(function (theme) {
  return {
    '@global': {
      html: {
        fontSize: theme.typography.htmlFontSize
      },
      // ".MuiSpeedDial-directionUp": {
      //   bottom: 64,
      //   right: 16,
      // },
      'a': {
        'color': theme.palette.secondary.main,
        'text-decoration': 'none'
      },
      '.add-to-home-banner': {
        backgroundColor: "black !important"
      },
      // 'li, p': {
      //   'color': 'rgba(0, 0, 0, 0.87)',
      //   'font-size': '1.125rem',
      //   'font-weight': 400,
      //   'font-family': '"Roboto", "Helvetica", "Arial", sans-serif',
      //   'line-height': '1.46429em'
      // },
      '*': {
        fontSize: theme.typography.fontSize,
        color: theme.palette.text.primary
      },
      'strong': _objectSpread(_objectSpread({}, theme.typography.body1), {}, {
        fontWeight: theme.typography.fontWeightBold
      }) // 'h3': {
      //   ...theme.typography.subheading1,
      //   color: theme.typography.h2.color
      // }

    },
    container: {
      paddingLeft: 0,
      paddingRight: 0
    }
  };
});

exports["default"] = _default;